import styled from 'styled-components';

export const PageContainer = styled.div`
  margin: 0 auto;
  max-width: 850px;
  width: 100%;
`;
